import React from "react";
import useStyles from "./Styles";
// Chart Imports
// import AreaChart from "./AreaChart/AreaChart";
// import GaugePie from "./GaugePieChart/GaugePie";
// import IrrigationView from "./CentralAZWaterUse/IrrigationView";
// import ChartTitle from "./ChartTitle";
import AreaChart from "../TechnicalView/AreaChart/AreaChart";
import GaugePie from "../TechnicalView/GaugePieChart/GaugePie";
import IrrigationView from "../TechnicalView/CentralAZWaterUse/IrrigationView";
import PolygonMapView from "../TechnicalView/PolygonMap/PolygonMapView";
import ColoradoRiverAccessMap from "../TechnicalView/ColoradoRiverAccess/ColoradoRiverAccessMap";
import ChartTitle from "../TechnicalView/ChartTitle";
import MetricsView from "./MetricsView";
import AboutTogglebar from "./AboutSidebar/AboutTogglebar";
import { Box } from "@material-ui/core";

function AllCharts(props) {
  const classes = useStyles();
  let map_view = props.map;

  return (
    <div className="mapContainer">
      <div
        ref={(node) => {
          if (node) {
            node.style.setProperty("display", "flex", "important");
          }
        }}
      >
        {map_view ? (
          <div className={classes.mapChartView}>
            <ChartTitle
              floating={true}
              title={"Colorado River Water Access"}
              subtitle={""}
              background="#EDEDED"
              chart_name="colorado_river_access"
            />
            <ColoradoRiverAccessMap />
          </div>
        ) : (
          <div className={classes.mapChartView}>
            <ChartTitle
              title={
                "Central Arizona Colorado River Water Access Per Person - Municipal Areas"
              }
              subtitle={""}
              chart_name="access_per_capita"
            />
            <PolygonMapView />
          </div>
        )}
        <AboutTogglebar about={""} />
      </div>
      <div className={classes.chartView}>
        <ChartTitle
          title={"Central Arizona Water Deliveries and Uses - 2020"}
          subtitle={""}
        />
        <MetricsView />
      </div>
      <div className={classes.irrigationChartView}>
        <ChartTitle
          title={"Central Arizona Water Deliveries and Uses - 2020"}
          subtitle={""}
          chart_name="central_az_water_use"
        />
        <IrrigationView />
      </div>
      <div className={classes.chartView}>
        <ChartTitle
          title={"Colorado River Access by Water Priority Level"}
          subtitle={""}
          chart_name="colorado_river_water_access"
        />
        <GaugePie />
      </div>
      <div className={classes.chartView}>
        <ChartTitle
          title={"  Central Arizona Colorado River Water Use vs. Access"}
          subtitle={""}
          chart_name="water_use_versus_access"
        />
        <AreaChart />
      </div>
    </div>
  );
}

export default AllCharts;
